export default {
    'OPERACION_MULT': (state, mutation) => {
        
        state.operacion = mutation.oper
        state.multimedia = mutation.multimedia
    }
}